module.exports = __webpack_public_path__ + "img/ABYDOS.8057f790.png";